// extracted by mini-css-extract-plugin
module.exports = {"confirmModal":"index__confirmModal___1kQP_","header":"index__header___25HRI","body":"index__body___200A4","footer":"index__footer___16keM"};